'use client';

import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { AdminSessionProvider, useAdminSession } from '@/contexts/AdminSessionContext';

const NAV = [
  { href: '/admin',              label: 'Dashboard',     icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
  { href: '/admin/empresas',     label: 'Empresas',      icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4' },
  { href: '/admin/usuarios',     label: 'Usuarios',      icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z' },
  { href: '/admin/pagos',        label: 'Pagos',         icon: 'M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z' },
  { href: '/admin/planes',        label: 'Planes',        icon: 'M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z' },
  { href: '/admin/suscripciones',label: 'Suscripciones', icon: 'M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z' },
  { href: '/admin/alertas',      label: 'Alertas',       icon: 'M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z' },
  { href: '/admin/logs',         label: 'Logs sistema',  icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
  { href: '/admin/auditoria',    label: 'Auditoría',     icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01' },
  { href: '/admin/tests',          label: 'Tests',         icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z' },
  { href: '/admin/configuracion',label: 'Configuración', icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z' },
];

function CambiarPasswordModal({ onClose, authHeaders }: { onClose: () => void; authHeaders: Record<string, string> }) {
  const API = process.env.NEXT_PUBLIC_API_URL ?? '';
  const [actual,  setActual]  = useState('');
  const [nueva,   setNueva]   = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving,  setSaving]  = useState(false);
  const [err,     setErr]     = useState('');
  const [ok,      setOk]      = useState(false);

  async function guardar() {
    setErr('');
    if (nueva.length < 8) { setErr('La nueva contraseña debe tener al menos 8 caracteres'); return; }
    if (nueva !== confirm) { setErr('Las contraseñas nuevas no coinciden'); return; }
    setSaving(true);
    try {
      const r = await fetch(`${API}/admin/auth/me/password`, {
        method: 'PATCH',
        headers: { ...authHeaders, 'Content-Type': 'application/json' },
        body: JSON.stringify({ passwordActual: actual, passwordNueva: nueva }),
      });
      const j = await r.json();
      if (!r.ok) throw new Error(j.error ?? 'Error desconocido');
      setOk(true);
    } catch (e: any) {
      setErr(e.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />
      <div className="relative bg-[#141414] border border-white/10 rounded-2xl w-full max-w-sm shadow-2xl p-6"
        onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-5">
          <h2 className="text-sm font-semibold text-white">Cambiar contraseña</h2>
          <button onClick={onClose} className="p-1.5 rounded-lg text-white/30 hover:text-white/70 hover:bg-white/8 transition-colors">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        {ok ? (
          <div className="text-center py-4">
            <p className="text-emerald-400 text-sm font-medium mb-1">Contraseña actualizada</p>
            <p className="text-white/40 text-xs">Usá la nueva contraseña la próxima vez que inicies sesión.</p>
            <button onClick={onClose} className="mt-4 px-4 py-2 bg-white/8 text-white/70 text-sm rounded-lg hover:bg-white/12 transition-colors">
              Cerrar
            </button>
          </div>
        ) : (
          <div className="space-y-3">
            {(['Contraseña actual', 'Nueva contraseña', 'Confirmar nueva'] as const).map((label, i) => {
              const val    = [actual, nueva, confirm][i];
              const setter = [setActual, setNueva, setConfirm][i];
              return (
                <div key={label} className="flex flex-col gap-1.5">
                  <label className="text-xs text-white/40">{label}</label>
                  <input type="password" value={val} onChange={e => setter(e.target.value)}
                    className="w-full bg-white/4 border border-white/10 rounded-xl px-3 py-2.5 text-sm text-white
                      placeholder:text-white/20 focus:outline-none focus:border-red-500/40 transition-colors" />
                </div>
              );
            })}
            {err && <p className="text-xs text-red-400">{err}</p>}
            <div className="flex gap-3 justify-end pt-2">
              <button onClick={onClose} className="px-4 py-2 text-sm text-white/40 hover:text-white/70 transition-colors">
                Cancelar
              </button>
              <button onClick={guardar} disabled={saving || !actual || !nueva || !confirm}
                className="px-4 py-2 bg-red-500 text-white text-sm font-semibold rounded-xl hover:bg-red-400
                  transition-colors disabled:opacity-40 disabled:cursor-not-allowed">
                {saving ? 'Guardando…' : 'Guardar'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function AdminLayoutInner({ children }: { children: React.ReactNode }) {
  const { admin, authHeaders, logout, hydrated } = useAdminSession();
  const pathname = usePathname();
  const router   = useRouter();
  const [isLight, setIsLight] = useState(false);
  const [modalPassword, setModalPassword] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    setIsLight(localStorage.getItem('mrcode-admin-theme') === 'light');
  }, []);

  function toggleTheme() {
    const next = !isLight;
    setIsLight(next);
    localStorage.setItem('mrcode-admin-theme', next ? 'light' : 'dark');
  }

  useEffect(() => {
    if (!hydrated) return;
    if (!admin && pathname !== '/admin/login') router.replace('/admin/login');
  }, [admin, hydrated, pathname]);

  // Esperar hidratación antes de decidir qué renderizar
  if (!hydrated) return null;

  if (!admin && pathname !== '/admin/login') return null;
  if (pathname === '/admin/login') return <>{children}</>;

  return (
    <div className={`flex h-screen overflow-hidden transition-colors duration-200 ${isLight ? 'admin-light bg-[#ECEAE1] text-[#0D0E1A]' : 'bg-[#0d0d0d] text-white'}`}>

      {/* Overlay mobile — cierra el sidebar al tocar fuera */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/60 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside className={`
        fixed inset-y-0 left-0 z-50 w-64 flex flex-col border-r shrink-0
        transition-transform duration-200
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
        md:static md:translate-x-0 md:w-56
        ${isLight ? 'border-black/10 bg-[#ECEAE1]' : 'border-white/6 bg-[#0d0d0d]'}
      `}>
        <div className={`px-5 h-14 flex items-center border-b gap-3 ${isLight ? 'border-black/10' : 'border-white/6'}`}>
          <div className="w-7 h-7 rounded-lg bg-red-500 flex items-center justify-center">
            <span className="text-xs font-black text-white">A</span>
          </div>
          <div>
            <p className={`text-xs font-bold leading-tight ${isLight ? 'text-[#0D0E1A]' : 'text-white'}`}>Admin Panel</p>
            <p className={`text-[10px] ${isLight ? 'text-black/40' : 'text-white/30'}`}>Mr Code</p>
          </div>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
          {NAV.map(item => {
            const isActive = item.href === '/admin' ? pathname === '/admin' : pathname.startsWith(item.href);
            return (
              <Link key={item.href} href={item.href} onClick={() => setSidebarOpen(false)}
                className={`flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-all ${
                  isActive
                    ? 'bg-red-500/15 text-red-500 border border-red-500/20'
                    : isLight
                      ? 'text-black/50 hover:text-black/80 hover:bg-black/8'
                      : 'text-white/40 hover:text-white/70 hover:bg-white/5'
                }`}>
                <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d={item.icon} />
                </svg>
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className={`p-3 border-t space-y-2 ${isLight ? 'border-black/10' : 'border-white/6'}`}>
          {/* Toggle tema */}
          <button onClick={toggleTheme} title={isLight ? 'Cambiar a modo oscuro' : 'Cambiar a modo claro'}
            className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-xs transition-colors ${
              isLight ? 'text-black/50 hover:text-black/80 hover:bg-black/8' : 'text-white/30 hover:text-white/60 hover:bg-white/5'
            }`}>
            {isLight ? (
              <svg className="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
              </svg>
            ) : (
              <svg className="w-3.5 h-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
            )}
            {isLight ? 'Modo oscuro' : 'Modo claro'}
          </button>

          {/* Usuario */}
          <div className={`flex items-center gap-2.5 px-3 py-2 rounded-lg ${isLight ? 'bg-black/5' : 'bg-white/3'}`}>
            <div className="w-7 h-7 rounded-full bg-red-500/20 border border-red-500/30 flex items-center justify-center shrink-0">
              <span className="text-xs font-bold text-red-400">{admin?.nombre[0]}</span>
            </div>
            <div className="flex-1 min-w-0">
              <p className={`text-xs font-semibold truncate ${isLight ? 'text-black/70' : 'text-white/80'}`}>{admin?.nombre}</p>
            </div>
            <button onClick={() => setModalPassword(true)} title="Cambiar contraseña"
              className={`p-1 rounded transition-colors ${isLight ? 'text-black/25 hover:text-black/60' : 'text-white/20 hover:text-white/60'}`}>
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
              </svg>
            </button>
            <button onClick={logout} title="Cerrar sesión"
              className={`p-1 rounded transition-colors ${isLight ? 'text-black/25 hover:text-red-500' : 'text-white/20 hover:text-red-400'}`}>
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
            </button>
          </div>
        </div>
      </aside>

      {/* Área principal */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header mobile — solo visible en pantallas pequeñas */}
        <div className={`md:hidden flex items-center gap-3 px-4 h-14 border-b shrink-0 ${isLight ? 'border-black/10' : 'border-white/6'}`}>
          <button
            onClick={() => setSidebarOpen(true)}
            className={`p-2 rounded-lg transition-colors ${isLight ? 'text-black/50 hover:text-black/80 hover:bg-black/8' : 'text-white/40 hover:text-white/70 hover:bg-white/8'}`}
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
              <rect y="2" width="18" height="2" rx="1"/>
              <rect y="8" width="18" height="2" rx="1"/>
              <rect y="14" width="18" height="2" rx="1"/>
            </svg>
          </button>
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded-md bg-red-500 flex items-center justify-center">
              <span className="text-[10px] font-black text-white">A</span>
            </div>
            <span className={`text-sm font-semibold ${isLight ? 'text-[#0D0E1A]' : 'text-white'}`}>Admin Panel</span>
          </div>
        </div>

        <main className="flex-1 overflow-y-auto px-4 py-5 md:px-8 md:py-7">{children}</main>
      </div>

      {modalPassword && (
        <CambiarPasswordModal
          onClose={() => setModalPassword(false)}
          authHeaders={authHeaders}
        />
      )}
    </div>
  );
}

export default function AdminLayout({ children }: { children: React.ReactNode }) {
  return (
    <AdminSessionProvider>
      <AdminLayoutInner>{children}</AdminLayoutInner>
    </AdminSessionProvider>
  );
}
